// Botões aceitos pela Meta nos templates, com o limite de cada tipo
// (Whatsapp::TemplateButtons no backend).
export const MAX_TEMPLATE_BUTTONS = 10;
export const BUTTON_TYPES = [
  {
    value: 'QUICK_REPLY',
    label: 'Personalizado',
    icon: 'i-lucide-reply',
    limit: 10,
  },
  {
    value: 'URL',
    label: 'Acessar o site',
    icon: 'i-lucide-external-link',
    limit: 2,
  },
  {
    value: 'VOICE_CALL',
    label: 'Ligar no WhatsApp',
    icon: 'i-simple-icons-whatsapp',
    limit: 1,
  },
  { value: 'PHONE_NUMBER', label: 'Ligar', icon: 'i-lucide-phone', limit: 1 },
  {
    value: 'FLOW',
    label: 'Concluir flow',
    icon: 'i-lucide-clipboard-list',
    limit: 10,
  },
  {
    value: 'COPY_CODE',
    label: 'Copiar código da oferta',
    icon: 'i-lucide-copy',
    limit: 1,
  },
];
export const COPY_CODE_TEXT = 'Copiar código';

export const emptyTemplateButton = (type = 'QUICK_REPLY') => ({
  type,
  text: '',
  url: '',
  phone_number: '',
  ttl_days: 7,
  flow_id: '',
  flow_action: 'navigate',
  navigate_screen: '',
  example: '',
});

// Botão vindo da Meta (edição) para o formulário.
export const templateButtonToForm = button => ({
  ...emptyTemplateButton(button.type),
  text: button.text || '',
  url: button.url || '',
  phone_number: button.phone_number || '',
  ttl_days: button.ttl_minutes ? Math.round(button.ttl_minutes / 1440) : 7,
  flow_id: button.flow_id ? String(button.flow_id) : '',
  flow_action: button.flow_action || 'navigate',
  navigate_screen: button.navigate_screen || '',
  example: Array.isArray(button.example)
    ? button.example[0] || ''
    : button.example || '',
});

export const hasButtonContent = button =>
  button.type === 'COPY_CODE'
    ? Boolean(String(button.example || '').trim())
    : Boolean(String(button.text || '').trim());

export const templateButtonPayload = button => ({
  type: button.type,
  text: button.type === 'COPY_CODE' ? COPY_CODE_TEXT : button.text,
  url: button.url,
  phone_number: button.phone_number,
  ...(button.type === 'VOICE_CALL'
    ? { ttl_minutes: Math.round(Number(button.ttl_days || 7) * 1440) }
    : {}),
  ...(button.type === 'FLOW'
    ? {
        flow_id: button.flow_id,
        flow_action: button.flow_action,
        navigate_screen: button.navigate_screen,
      }
    : {}),
  ...(button.type === 'COPY_CODE' ? { example: button.example } : {}),
});

// Faixas do período de validade (message_send_ttl_seconds) por categoria.
export const TTL_RANGES = {
  UTILITY: { min: 30, max: 43200, default: 3600 },
  AUTHENTICATION: { min: 30, max: 900, default: 600 },
  MARKETING: { min: 43200, max: 2592000, default: 86400 },
};
